/**
 * @generated SignedSource<<76d2fb8c879ff6776af930854c136f7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTaskMultipleRenderTask_taskExecution$data = {
  readonly routineOccasion: {
    readonly endAt: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskMultipleRenderTaskContent_taskExecution">;
  readonly " $fragmentType": "WidgetTaskMultipleRenderTask_taskExecution";
};
export type WidgetTaskMultipleRenderTask_taskExecution$key = {
  readonly " $data"?: WidgetTaskMultipleRenderTask_taskExecution$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskMultipleRenderTask_taskExecution">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTaskMultipleRenderTask_taskExecution",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTaskMultipleRenderTaskContent_taskExecution"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineOccasion",
      "kind": "LinkedField",
      "name": "routineOccasion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TaskExecution",
  "abstractKey": "__isTaskExecution"
};

(node as any).hash = "f51f4f85ca87333f229fc54cf4b5dbc5";

export default node;
